import { useChangePassword, useResolverForm } from '@hooks';
import { ValidationUtils } from '@utils';
import React, { memo, useCallback } from 'react';
import { Controller } from 'react-hook-form';
import trans from 'translation';
import { KButton, KForm, KGrid, KInput } from 'uikit';
import * as yup from 'yup';

interface IFormData {
  password: string;
  newPassword: string;
}

const schema = yup.object().shape({
  password: ValidationUtils.required(),
  newPassword: ValidationUtils.required()
});

const ChangePassword = () => {
  const methods = useResolverForm<IFormData>({
    schema,
    configs: {
      defaultValues: {
        password: '',
        newPassword: ''
      }
    }
  });

  const { mutate, isLoading } = useChangePassword();

  const onFormValid = useCallback(
    (data: IFormData) => {
      mutate(data);
    },
    [mutate]
  );

  return (
    <KForm onSubmit={methods.handleSubmit(onFormValid)}>
      <KGrid.Container>
        <KGrid.Item xs={12}>
          <Controller
            control={methods.control}
            name="password"
            render={({ field, fieldState: { error } }) => {
              return (
                <KInput.Password
                  {...field}
                  label={trans('current_password')}
                  required
                  message={error?.message}
                />
              );
            }}
          />
        </KGrid.Item>

        <KGrid.Item xs={12}>
          <Controller
            control={methods.control}
            name="newPassword"
            render={({ field, fieldState: { error } }) => {
              return (
                <KInput.Password
                  {...field}
                  label={trans('new_password')}
                  required
                  message={error?.message}
                />
              );
            }}
          />
        </KGrid.Item>

        <KGrid.Item xs={12} style={{ textAlign: 'right' }}>
          <KButton.Solid
            type="submit"
            title={trans('submit')}
            isLoading={isLoading}
          />
        </KGrid.Item>
      </KGrid.Container>
    </KForm>
  );
};

export default memo(ChangePassword);
